import * as types from 'models/actionTypes'

export const requestFurniture = () => ({
    type: types.REQUEST_FURNITURE_SAGA,
})

// This is receiving a filtered, paginated result
export const receiveFurniture = (furniture, filter, count, hasNext, moreToken) => ({
    type: types.RECEIVE_FURNITURE,
    furniture,
    filter,
    count,
    hasNext,
    moreToken,
})

export const failedReceiveFurniture = () => ({
    type: types.FAILED_RECEIVE_FURNITURE,
})

export const requestFurnitureByIds = (ids) => ({
    type: types.REQUEST_FURNITURE_BY_IDS_SAGA,
    ids,
})

export const receiveFurnitureByIds = (furniture) => ({
    type: types.RECEIVE_FURNITURE_BY_IDS,
    furniture,
})

export const failedReceiveFurnitureByIds = () => ({
    type: types.FAILED_RECEIVE_FURNITURE_BY_IDS,
})

export const requestFurnitureByLocalItemNos = (localItemNos) => ({
    type: types.REQUEST_FURNITURE_BY_LOCALITEMNOS_SAGA,
    localItemNos,
})

export const receiveFurnitureByLocalItemNos = (furniture) => ({
    type: types.RECEIVE_FURNITURE_BY_LOCALITEMNOS,
    furniture,
})

export const failedReceiveFurnitureByLocalItemNos = () => ({
    type: types.FAILED_RECEIVE_FURNITURE_BY_LOCALITEMNOS,
})

export const requestFurnitureCategories = (region) => ({
    type: types.REQUEST_FURNITURE_CATEGORIES_SAGA,
    region,
})

export const receiveFurnitureCategories = (categories) => ({
    type: types.RECEIVE_FURNITURE_CATEGORIES,
    categories,
})

export const failedReceiveFurnitureCategories = () => ({
    type: types.FAILED_RECEIVE_FURNITURE_CATEGORIES,
})

export const requestFurnitureSwappables = (id) => ({
    type: types.REQUEST_FURNITURE_SWAPPABLES_SAGA,
    id,
})

export const receiveFurnitureSwappables = (furniture, id) => ({
    type: types.RECEIVE_FURNITURE_SWAPPABLES,
    furniture,
    id,
})

export const failedReceiveFurnitureSwappables = () => ({
    type: types.FAILED_RECEIVE_FURNITURE_SWAPPABLES,
})

export const requestFurnitureCombinables = (id, uniqueId, slotCategory, size, variant, nodeIndex) => ({
    type: types.REQUEST_FURNITURE_COMBINABLES_SAGA,
    id,
    uniqueId,
    slotCategory,
    size,
    variant,
    nodeIndex,
})

export const receiveFurnitureCombinables = (furniture, parentId, parentUniqueId, nodeIndex) => ({
    type: types.RECEIVE_FURNITURE_COMBINABLES,
    furniture,
    parentId,
    parentUniqueId,
    nodeIndex,
})

export const failedReceiveFurnitureCombinables = () => ({
    type: types.FAILED_RECEIVE_FURNITURE_COMBINABLES,
})

export const selectFurniture = (id) => ({
    type: types.SELECT_FURNITURE,
    id,
})

export const selectSwapFurnitureForDetails = (id) => ({
    type: types.SELECT_FURNITURE_SWAP_DETAILS,
    id,
})

export const updateFurnitureFilter = (filter, trackingInfo = null) => ({
    type: types.FURNITURE_FILTER_UPDATE,
    filter,
    trackingInfo,
})

export const clearFurnitureFilter = () => ({
    type: types.FURNITURE_FILTER_CLEAR,
})

export const filterFeaturedProducts = () => ({
    type: types.FILTER_FEATURED_PRODUCTS,
})
